import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nContext";
import { useIsAndroidApp } from "@/hooks/useLaunchContext";

export default function FinalCTA() {
  const { t } = useI18n();
  const isTwaApp = useIsAndroidApp();
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-primary px-8 py-16 text-center sm:px-16">
          <h2 className="font-heading text-2xl font-medium tracking-tight text-primary-foreground sm:text-3xl lg:text-4xl">
            {t("landing.finalCtaTitle")}
          </h2>
          {!isTwaApp && <p className="mx-auto mt-4 max-w-xl text-base text-primary-foreground/85">{t("landing.finalCtaSubtitle")}</p>}
          <Button asChild size="lg" variant="secondary" className="mt-8 rounded-full px-8 transition-transform hover:-translate-y-1">
            <Link to="/create">
              {t("landing.heroCta")}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
